import React from "react";
import customAxios from "../../API/customAxios";
import moment from "moment";

export async function getApproves(getCountOnly = false) {
  const endpoint = getCountOnly ? `/get_approves?getCountOnly=true` : `/get_approves`;
  return await customAxios.get(endpoint);
}

export async function getApprovalHistory(searchFromDate,searchToDate) {
  return await customAxios.post(`/get_approval_history`, {
    startDate: moment(toNativeDate(searchFromDate)).format(window.global.momentFormat),
    endDate: moment(toNativeDate(searchToDate)).format(window.global.momentFormat),
  });
}

function toNativeDate(date) {
  return new Date(date.year, date.month - 1, date.day);
}